// extracted by mini-css-extract-plugin
export default {"option":"LastUsedBadge_option__LP1Vw","badge":"LastUsedBadge_badge__17pGS"};